export const getNamesFromFileList = (files: FileList | File[]): string[] => {
  return Array.from(files).map(f => f.name);
};

export const getFileExtension = (fileName): string => {
  const regex = new RegExp('.([A-Za-z0-9]+)$');
  const fileExtension = regex.exec(fileName)[0];
  return fileExtension;
};

export const getHeaders = (file: File): Promise<string[]> => {
  return new Promise<string[]>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const csv = reader.result as string; // the entire file
      const allTextLines = csv.replace(/\r/gm, '').split('\n');

      // Removing trailing consecutive commas to remove empty column names
      const trailingCommas = allTextLines[0].match(/,+$/);
      if (trailingCommas) {
        allTextLines[0] = allTextLines[0].slice(0, trailingCommas.index);
      }
      const headers: string[] = allTextLines[0].split(',').map(h => h.trim());

      resolve(headers);
    };
    reader.onerror = () => reject('Error');
    reader.readAsText(file.slice(0, 10000), 'UTF-8');
  });
};

export const removeEmptyLinesFromCSV = (file: File): Promise<File> => {
  return new Promise<File>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const csv = (reader.result as string).replace(/\r/gm, ''); // the entire file
      const allTextLines = csv.split('\n');

      // Removing trailing consecutive commas to remove empty column names
      const trailingCommas = allTextLines[0].match(/,+$/);
      if (trailingCommas) {
        allTextLines[0] = allTextLines[0].slice(0, trailingCommas.index);
      }
      const headers: string[] = allTextLines[0].split(',').map(h => h.trim());
      const columns = headers.length;

      // Remove empty lines, trim fields, format dates
      const trimmedLines =
        allTextLines
          .filter(l => !l.trim().match(/^[", ]*$/))
          .map(l =>
            l
              .split(',')
              .slice(0, columns)
              .map(w => w.trim())
              .join(',')
          )
          .join('\r\n') + '\r\n';

      const blob = new Blob([trimmedLines], { type: file.type });
      const newFile = blobToFile(blob, file);

      resolve(newFile);
    };
    reader.onerror = ev => reject('Error');
    reader.readAsText(file, 'UTF-8');
  });
};

const blobToFile = (blob: Blob, file: File): File =>
  new File([blob], file.name, {
    lastModified: file.lastModified,
    type: file.type
  });
